import React from 'react';
import { useHistory, Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function FourZerofour() {
    let history = useHistory();
    return (
<>   
    <Helmet link={
        [{"rel": "stylesheet", "href": 'css/Profile-stats.css'}]
    }/>
    <div className="row no-gutters">
        <div className="bg-grey application">
            <div className="appHeader bg-transparent text-dark position-relative">
                <div className="left">
                    <a className="headerButton goBack"   onClick={() => history.goBack()}>
                        <img alt="" src={require("./../images/back-blue.png").default} className="img-fluid" />
                    </a>
                </div>
                <div className="pageTitle"></div>
            </div>
            <Link to="/distributor-home" className="section my-4 text-center">
                <img alt="" src={require("./../images/404.png").default} className="img-fluid" />
            </Link>
        </div>
        <div className="bg"></div>
    </div>
</>
    );
}

export default FourZerofour;
